<template>
  <div>
    <b-form-row>
      <b-col>
        <b-button @click="onShow" size="sm" variant="success"
          ><i class="fas fa-sync"></i> Atualizar Lista</b-button
        >
      </b-col>
      <b-col>
        <b-button @click="doChangeOption" size="sm" variant="secondary"
        class="float-right"
          ><i class="fas fa-eye-slash"></i> Lista de Tarefas</b-button>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <gantt-elastic :tasks="tasks" :options="options"></gantt-elastic>
      </b-col>
    </b-form-row>
  </div>
</template>

<script>
import GanttElastic from "gantt-elastic";
import moment from "moment";
import axios from "axios";

import { baseApiUrl, showError, ganttOptionsReadOnly } from "@/global";
export default {
  name: "SubTabPlanejamentoSintetico",
  components: { GanttElastic },
  props: {
    wbs: { type: Object, required: true },
  },
  data: function() {
    return {
      tasks: [
        {
          id: 0,
          label: "",
          start: moment()
            .startOf("day")
            .valueOf(),
          duration: 0,
        },
      ],
      options: {...ganttOptionsReadOnly},
    };
  },
  methods: {
    doChangeOption() {
      let _opt = { ...this.options };
      _opt.taskList.display = !this.options.taskList.display;
      this.options = _opt;
    },
    onShow() {
      axios
        .get(`${baseApiUrl}/bid/cronograma/listar`, {
          params: {
            programa_id: this.wbs.programa_id,
            wbs_id: this.wbs.wbs_id,
            sintetico: 1,
          },
        })
        .then((resp) => {
          var _new = [];
          resp.data.forEach((element) => {
            let _model = {
              id: element.registro_id,
              label: element.descricao,
              start: moment(element.dt_inicio, "YYYY-MM-DD")
                .startOf("day")
                .valueOf(),
              end: moment(element.dt_termino, "YYYY-MM-DD")
                .endOf("day")
                .valueOf(),
              duration:
                (moment(element.dt_termino, "YYYY-MM-DD").diff(
                  moment(element.dt_inicio, "YYYY-MM-DD"),
                  "days"
                ) +
                  1) *
                24 *
                60 *
                60 *
                1000,
              type: element.type || "task",
              progress: 0,
              collapsed: "collapsed",
              style: {
                base: {
                  fill: element.cor || "#1EBC61",
                  stroke: "#0EAC51",
                },
              },
            };
            if (element.predecessora_id > 0)
              _model.dependentOn = [element.predecessora_id];

            if (element.parentId) _model.parentId = element.parentId;

            _new.push(_model);
          });

          if (_new.length > 0) {
            this.tasks = _new;
          } else
            this.tasks = [
              {
                id: -1,
                label: "Sem Dados a Exibir",
                start: moment()
                  .startOf("day")
                  .valueOf(),
                duration: 0,
              },
            ];
        })
        .catch((err) => {
          console.log(err);
          showError(err);
        });
    },
  },
  mounted() {
    this.onShow();
  },
};
</script>

<style lang="scss">
.gantt-elastic__task-list-header-column {
  background-color: #343a40 !important;
  color: white !important;
}

.gantt-elastic__calendar-row-rect-child--month {
  background-color: #343a40 !important;
}

.gantt-elastic__calendar-row-text--month {
  color: white !important;
}

.gantt-elastic__calendar-row-rect-child--day {
  background-color: #343a40 !important;
}
.gantt-elastic__calendar-row-text--day {
  color: white !important;
}

.gantt-elastic__task-list-header {
  height: 41px !important;
}

.gantt-elastic__task-list-item:hover {
    background-color: #aaa !important;
    color: white !important;
    transition: 250ms;
    .gantt-elastic__task-list-item-value{
      background-color: #aaa !important;
      color: white !important;
      transition: 250ms;
    }
}



</style>
